import cx from 'classnames'
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns'

import useCountdown from 'src/hooks/useCountdown'

import classes from './styles.module.scss'
import { getFormattedTimerValue } from './utils'

type Props = {
  nextGameStart: number
  with3DImage?: boolean
}

function CountdownTimer({ nextGameStart, with3DImage }: Props) {
  const countdown = useCountdown(nextGameStart)

  const days = differenceInDays(nextGameStart, Date.now())
  const hours = differenceInHours(nextGameStart, Date.now()) % 24
  const minutes = differenceInMinutes(nextGameStart, Date.now()) % 60
  const seconds = differenceInSeconds(nextGameStart, Date.now()) % 60
  const countdownValue = countdown <= 0 ? 'Started' : getFormattedTimerValue(days, hours, minutes, seconds)

  return <div className={cx(classes.root, with3DImage && classes.root3D)}>{countdownValue}</div>
}

export default CountdownTimer
